import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConnector = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 68,
	height: 72,
	viewBox: "0 0 68 72",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 4.5,
			y1: 66,
			x2: 4.5,
			y2: 10,
			stroke: "#2C3F81"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 3,
			y1: 67.5,
			x2: 59,
			y2: 67.5,
			stroke: "#2C3F81"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 5,
			cy: 5,
			r: 4,
			stroke: "#2C3F81",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 63,
			cy: 67,
			r: 4,
			stroke: "#2C3F81",
			strokeWidth: 2
		})
	]
});
export default SvgConnector;
